import { Box, Chip, Stack, useTheme } from "@mui/material";
import { ArrowUpDownIcon, EyeOffIcon } from "lucide-react";
import type { Control } from "react-hook-form";
import { useWatch } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { hiddenPortfolioCategories } from "web_myplann/Portfolio/Helpers/hiddenPortfolioCategories";
import { portfolioGroupLabel } from "web_myplann/Portfolio/Helpers/portfolioCategoryMapping";
import { useEffectivePortfolioFilter } from "web_myplann/Portfolio/Hooks/useEffectivePortfolioFilter";
import { defaultPortfolioFilterState } from "web_myplann/Shared/State/portfolioFilterAtom";

type Props = {
	control: Control<FilterFormValues>;
};

export const ActiveFiltersSummary = ({ control }: Props) => {
	const { t } = useResource();
	const theme = useTheme();
	const { availableCategories } = useEffectivePortfolioFilter();
	const { categories, sort } = useWatch({ control });

	const activeSort = sort ?? defaultPortfolioFilterState.sort;
	const hiddenCategories = hiddenPortfolioCategories(
		categories ?? [],
		availableCategories,
	);
	const showSortChip = activeSort !== defaultPortfolioFilterState.sort;

	if (hiddenCategories.length === 0 && !showSortChip) {
		return null;
	}

	return (
		<Box px={theme.spacingTokens.lg} pt={theme.spacingTokens.lg}>
			<Stack
				direction="row"
				flexWrap="wrap"
				gap={theme.spacingTokens.sm}
				aria-label={t(
					Resources.Portfolio.List.Redesign.Filter.activeSummaryLabel,
				)}
			>
				{hiddenCategories.map((id) => (
					<Chip
						key={id}
						variant="tag"
						icon={<EyeOffIcon size={theme.iconSize.xs} />}
						label={t(portfolioGroupLabel(id))}
					/>
				))}
				{showSortChip && (
					<Chip
						variant="tag"
						icon={<ArrowUpDownIcon size={theme.iconSize.xs} />}
						label={t(Resources.Portfolio.List.Redesign.Sort[activeSort])}
					/>
				)}
			</Stack>
		</Box>
	);
};
